<template>
    <!-- 历史名人 遍历 -->
    <div>
        <div class="person-item" v-for="item in list" :key="item.id">
            <!-- 人物生平简介 -->
            <div class="divider"></div>
            <div class="intr box" v-if="item.introduce && item.introduce.length">
                <div class="cover-wrap">
                    <van-image @click="go2person(item)" :src="item.cover" width="20vw" height="20vw"/>
                </div>
                <div>
                    <!-- 点击前往名人详情 -->
                    <div class="intr-title subtitle" @click="go2person(item)">{{item.title}}生平简介</div>
                    <introduction :intr="item.introduce" :limit="80"/>
                </div>
            </div>

            <!-- 名人故事 -->
            <div class="book box" v-if="item.stories && item.stories.length">
                <resource-list-hor coverType="story" :list="getStoryList(item.stories)"/>
            </div>
            <div class="divider"></div>
        </div>
    </div>
</template>

<script>
import ResourceListHor from '@/components/resourceListHor'
import Introduction from "@/components/introduction";
import {calcHtml} from "@/views/personage/CalcResourceHorList";

export default {
    name: "personList",
    // 历史名人
    props:['list'],
    components: {
        ResourceListHor,
        Introduction
    },
    methods:{
        getStoryList(list){
            return calcHtml(list)
        },
        go2person(item){
            this.$router.push(`/personage/detail/${item.id}`)
        }
    }
}
</script>

<style scoped>
.divider {
    width: 100vw;
    height: 5px;
    background: #EFEFEF;
    margin-top: 10px;
}
.box {
    padding: 10px;
    position: relative;
}
.intr{
    display: flex;
    justify-content: space-between;
}
.cover-wrap{
    display: flex;
    justify-content: center;
    flex-direction: column;
}
</style>
